import { render } from "./BaseButton.vue?vue&type=template&id=163d65b0&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=ts"
export * from "./BaseButton.vue?vue&type=script&lang=ts"

import "./BaseButton.vue?vue&type=style&index=0&id=163d65b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-163d65b0"

export default script